import React from 'react';
import PropTypes from 'prop-types';
import styledComponent from '../../utils/styledComponent';
import theme from '../../theme';

// Big-number-over-caption stat tile. Extracted from the repeated
// statValue pattern (HeadcountSection, ConsolidateSelectedModal).
// `tone="warning"` marks a value that needs the viewer's attention
// (e.g. fewer drivers available than routes planned).

const StyledDiv = styledComponent('div', {
  textAlign: 'center',
  background: theme.colors.bgCard,
  border: theme.borders.card,
  borderRadius: theme.radii.inner,
  padding: theme.spacing.fieldGap,

  '&.st-tile-warning': {
    background: theme.colors.warningBg,
    borderColor: theme.colors.warning,
  },

  '& .st-value': {
    fontSize: theme.typography.statValue.fontSize,
    fontWeight: theme.typography.statValue.fontWeight,
    color: theme.colors.primary,
    lineHeight: theme.lineHeights.tight,
    marginBottom: theme.spacing.labelGap,
  },
  '& .st-value-warning': {
    color: theme.colors.warningText,
  },
  '& .st-label': {
    fontSize: theme.sizes.smallFontSize,
    color: theme.colors.textMuted,
  },
  '& .st-note': {
    fontSize: theme.sizes.smallFontSize,
    color: theme.colors.warningText,
    fontWeight: theme.fontWeights.medium,
    marginTop: theme.spacing.labelGap,
  },
});

function StatTile({ value, label, tone, note, testId }) {
  const warning = tone === 'warning';
  return (
    <StyledDiv
      className={warning ? 'st-tile st-tile-warning' : 'st-tile'}
      data-testid={testId}
    >
      <div className={warning ? 'st-value st-value-warning' : 'st-value'}>
        {warning ? '⚠ ' : ''}
        {value}
      </div>
      <div className="st-label">{label}</div>
      {note ? <div className="st-note">{note}</div> : null}
    </StyledDiv>
  );
}

StatTile.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  label: PropTypes.string.isRequired,
  tone: PropTypes.oneOf(['default', 'warning']),
  note: PropTypes.string,
  testId: PropTypes.string,
};

StatTile.defaultProps = {
  tone: 'default',
  note: '',
  testId: undefined,
};

export default StatTile;
